<template>
    <nav id="menu-tools" class="hide-scrollbar" :class="{ 'opened-menu': openedMenu }">
        <div class="account" v-if="openedMenu">
            <img class="avatar" :src="locationData.avatar" />
            <div class="name">{{ locationData.name }}</div>
        </div>

        <div class="alex-space">
            <div class="alex-face" @click="goHome()">
                <div v-if="alexIcon" class="alex-face" :style="{ backgroundImage: 'url(' + alexIcon + ')' }" @click="goHome()"></div>
                <LottieAnimation v-else :timeToRepeat="10000" :loopAnimation="true" :animationName="'andy.json'" />
            </div>
            <div class="open-message" v-if="employeeName">{{ $t(CustomWelcomeMessage) }}, {{ employeeName }}!</div>
            <div class="open-message" v-else>{{ $t(CustomWelcomeMessage) }}!</div>
        </div>

        <div class="menu-box" ref="menubox">
            <div class="ask-tool-message">{{ $t('tooltip.what_do_now') }}</div>
            <ul class="menu-list hide-scrollbar">
                <!-- RENEW WARN -->
                <li class="item narrow-tools-menu-visible" id="navRenew" key="main_tools_renew" v-if="renewLicense && daysLeft > 0" @click="openRenewPopup">
                    <span class="text" v-html="$t('menu_tools.renew_title')"></span>
                    <span class="description" v-html="$t('menu_tools.renew_description')"></span>
                </li>

                <!-- ALERTS WARN -->
                <li class="item narrow-tools-menu-visible" id="navAlerts" key="main_tools_alerts" v-if="withAlerts" @click="openAlertsView">
                    <i class="i-andy-exclamation i-andy-ml"></i>
                    <div class="text-box">
                        <span class="text" v-html="$t('menu_tools.alerts_title')"></span>
                        <span class="description" v-html="$t('menu_tools.alerts_description')"></span>
                    </div>
                </li>

                <!-- ANDY TOOLS -->
                <template v-for="(tool, i) in tools">
                    <li class="item tool-item" :class="{ selected: isToolSelected(tool.action), 'narrow-tools-menu-visible': showInNarrowToolsMenu(tool) }" :id="tool.id" v-if="isMenuToolVisible(tool)" @click="navTool(tool.action)" :key="'main_tools' + i">
                        <span class="menu-tool-icon-wrapper">
                            <i v-if="tool.icon" class="i-andy-l menu-tool-icon" :class="tool.icon"></i>
                            <span v-if="isRadarTool(tool) && hasRadarContent" class="radar-notification-badge"></span>
                        </span>
                        <div class="text-box">
                            <span class="text">{{ $t(tool.name) }}</span>
                            <span class="description">{{ $t(tool.name + '_description') }}</span>
                        </div>
                    </li>
                </template>

                <!-- EXTERNAL TOOLS -->
                <template v-for="(tool, i) in Object.values(external_tools)">
                    <li class="item tool-item" :class="{ selected: isToolSelected(tool.action), 'narrow-tools-menu-visible': showExternalTool(tool, i) }" v-if="tool.type && (tool.type != 'intent' || isAPP)" @click="navToolExternal(tool)" :key="'external_tools' + i">
                        <div v-if="tool.icon" class="menu-tool-icon external-tool-icon" :style="{ backgroundImage: 'url(' + tool.icon + ')' }"></div>
                        <div class="text-box">
                            <span class="text">{{ tool.name }}</span>
                            <span class="description" v-if="tool.description">{{ tool.description }}</span>
                        </div>
                    </li>
                </template>

                <li class="item" v-if="!isPWA" :style="{ backgroundImage: 'url(' + cssImage + 'android_bttn.png)' }" @click="installPWA()">
                    <span class="text">Install PWA</span>
                </li>

                <!-- CONFIG TOOL -->
                <li class="item" v-if="settingsAvailable" :class="{ selected: isToolSelected('/config'), 'narrow-tools-menu-visible': toolsNumber >= visibleTools.length - 1 }" id="navConfig" @click="navTool('/config/location')">
                    <i class="i-andy-l menu-tool-icon i-andy-menu-config"></i>
                    <div class="text-box">
                        <span class="text">{{ $t('menu_tools.config_title') }}</span>
                    </div>
                </li>
            </ul>

            <div class="info" v-if="AlexInfoUrl">
                <a rel="noreferrer" target="_blank" :href="AlexInfoUrl">{{ $t('tooltip.more_about_alex') }}</a>
            </div>

            <!-- <div class="helpcenter">
        <a
          class="link"
          target="_blank"
          :href="helpCenterUrl"
        >{{ $t('tooltip.helpcenter') }}</a>
      </div> -->

            <div class="expand-arrow" @click="toggleMenu"></div>

            <div class="ticketing" @click="navTool('/tickets')" :class="{ selected: isToolSelected('/tickets') && !openedMenu }"></div>
            <div class="expand-tools" @click="toggleMenu"></div>
        </div>

        <Copyright></Copyright>

        <div class="version" v-if="openedMenu">{{ $t('tooltip.version') }}: {{ appVersion }}</div>
    </nav>
</template>

<script>
import LottieAnimation from '@/components/layout/LottieAnimation.vue'
import Copyright from '@/components/layout/Copyright'

export default {
    components: { Copyright, LottieAnimation },
    data() {
        return {
            showingInfo: '',
            intowinUrl: 'https://intowin.io/',
            cssImage: css_image_url,
            // Máx. ítems visibles en el menú lateral estrecho (~78px por ítem)
            toolsNumber: parseInt((window.innerHeight - 100) / 78) - 1,
            // Total de herramientas Andy; usado para reservar slots a externas
            alexTools: 0
        }
    },
    computed: {
        isAuditorLogin() {
            return (this.$store.getters.isAuditorLogin || this.$store.getters['loginUser/getAuditor']) && this.$route.name !== 'Login'
        },
        showRadarTool() {
            return this.$store.getters['getShowRadarTool']
        },
        hasRadarContent() {
            return this.$store.getters['radar/getHasRadarContent']
        },
        releases() {
            return this.$store.getters['login/getAllReleases']()
        },
        locationData() {
            return this.$store.getters['loginUser/getLocalLocation']
        },
        home() {
            return this.$store.getters['getHome'] ? this.$store.getters['getHome'] : '/home'
        },
        settingsAvailable() {
            return this.$store.getters.getSettingsAvailable
        },
        connState() {
            return this.$store.getters['getConnState']
        },
        alexIcon() {
            return this.$store.getters.getAppIcon
        },
        isLicenseExpired() {
            if (!this.renewLicense) return false
            const now = moment()
            const licenseEndDate = moment(this.renewLicense)

            return now.isSameOrAfter(licenseEndDate)
        },
        renewLicense() {
            const licenseEndDate = this.$store.getters['getLicenseEndDate']
            return licenseEndDate
        },
        daysLeft() {
            const expireDate = this.renewLicense ? moment(this.renewLicense) : false

            if (!expireDate) return 0
            if (!expireDate.isValid()) return 0

            const now = moment()
            const differenceDays = expireDate.diff(now, 'days') + 1
            if (isNaN(differenceDays)) return 0
            return now.isAfter(expireDate) ? 0 : differenceDays
        },
        withAlerts() {
            let config = this.$store.getters['login/getConfig']
            if (config && (typeof config.show_alerts == 'undefined' || !config.show_alerts)) return false
            const sensorHome = this.$store.getters['sensor/getSensorHome']
            let issues = this.$store.getters['getAlertsActive']
            let alerts = sensorHome.alerts
            let inactive = sensorHome.inactive
            let turnedOff = sensorHome.turned_off
            let active = alerts > 0 || inactive > 0 || turnedOff > 0
            for (var key in issues) {
                if (!active && issues[key] > 0) active = true
            }
            return active
        },

        userRole() {
            var user = this.$store.getters['employee/getEmployee'](this.emp_id)
            var roles = this.$store.getters['employee/getAllRoles']
            if (user && Object.keys(roles).length > 0) {
                return parseInt(roles[user.rol].level)
            }
        },
        // KITCHEN MODE FEATURE FLAG
        kitchenModeFeatureFlag() {
            return this.$store.getters.isKitchenModeActive
        },
        // TOOLS
        tools() {
            const self = this

            let tools

            const allTools = self.$store.getters['getMenuToolsByRoleLevel'](9)

            // FOR KITCHEN MODE HOME WIDGETS (show all tools)
            if (self.$store.getters.isKitchenModeActive) {
                // show all tools if the current page is Home Widgets and Kitchen Mode is on
                tools = allTools
            } else {
                // for the rest of the pages (show tools depending on user role)
                tools = self.$store.getters['getMenuToolsByRoleLevel'](self.userRole)
            }

            const aTools = this.$store.getters['sortToolsForSidebar'](tools)

            // Cuenta herramientas Andy visibles para reservar slots en el menú estrecho
            self.alexTools = 0
            aTools.forEach((tool) => {
                if (self.isMenuToolVisible(tool)) self.alexTools++
            })

            return aTools
        },
        // Herramientas que ocupan slot en el menú lateral estrecho, en el mismo orden que el menú extendido
        narrowToolsMenuIds() {
            return this.tools
                .filter((tool) => this.isMenuToolVisible(tool))
                .slice(0, this.toolsNumber + 3)
                .map((tool) => tool.id)
        },
        external_tools() {
            var tools = this.$store.getters['getMenuToolsByRoleLevel'](this.userRole)
            var aTools = []
            for (var k in tools) {
                var tool = tools[k]
                if (typeof tool.type !== 'undefined') aTools.push(tool)
            }

            return this.$store.getters['sortToolsForSidebar'](aTools)
        },
        isPWA() {
            // Check if user is in PWA
            /* This line is only for hide the button (delete this to see the button) */ return true
            return window.matchMedia('(display-mode: standalone)').matches
        },
        isAPP() {
            return process.env.VUE_APP_IS_APP == 'TRUE'
        },
        // Códigos de herramientas habilitadas en la cuenta (excluye 8 y 9)
        visibleTools() {
            var visible = []
            const config = this.$store.getters['login/getConfig']
            if (config && config.tools) {
                config.tools.forEach((tool) => {
                    const code = Number(tool)
                    if (![8, 9].includes(code)) {
                        visible.push(code)
                    }
                })
            }

            return visible
        },
        openedMenu() {
            return this.$store.state['menu_tools_is_expanded']
        },
        location() {
            return this.$route.path
        },
        CustomWelcomeMessage() {
            var hour = new Date().getHours()
            if (hour >= 6 && hour < 12) {
                return 'tooltip.morning'
            } else if (hour >= 12 && hour < 20) {
                return 'tooltip.afternoon'
            } else return 'tooltip.night'
        },
        emp_id() {
            return this.$store.getters['loginUser/getLocalEmployee']
        },
        employeeName() {
            var employee = this.$store.getters['employee/getEmployee'](this.emp_id)
            if (employee) {
                return employee.name.replace(/ .*/, '')
            }
        },
        AlexInfoUrl() {
            const config = this.$store.getters['login/getConfig']
            if (config) {
                if (config.hasOwnProperty('alex_info_url') && config.alex == false) {
                    return false
                } else {
                    return this.$store.getters.getAlexInfoUrl
                }
            } else return this.$store.getters.getAlexInfoUrl
        },
        appVersion() {
            return process.env.VUE_APP_VERSION ? process.env.VUE_APP_VERSION : ''
        }
    },
    updated: function () {
        // Recalcula toolsNumber según la altura disponible del menú lateral estrecho
        if (this.$refs.menubox != undefined) {
            var menuHeight = this.$refs.menubox.clientHeight
            this.toolsNumber = Math.round((menuHeight - 140) / 78)
        } else {
            var menuHeight = window.innerHeight
            this.toolsNumber = Math.round((menuHeight - 210) / 78)
        }
    },
    methods: {
        openRenewPopup() {
            if (this.isLicenseExpired) {
                return
            }
            this.$popup.renew({
                message: this.$t('popup.renew.message', { days: this.daysLeft })
            })
        },
        openAlertsView() {
            let self = this
            const alertsPath = '/alerts'

            self.$router.push(alertsPath).catch((err) => {
                if (err && err.name == 'NavigationDuplicated') {
                    self.$router.push('/reset' + alertsPath)
                }
            })
        },
        goHome() {
            var self = this
            self.$router.push(self.$root.redirectPath(self.home)).catch((err) => {
                if (err.name == 'NavigationDuplicated') {
                    self.$router.push('/reset' + self.redirectPath(self.home))
                }
            })
        },
        currentEmployee() {
            var emp_id = this.$store.getters['loginUser/getLocalEmployee']

            if (emp_id) {
                var emp = this.$store.getters['employee/getEmployee'](emp_id)
            } else {
                var emp = this.$store.getters['loginUser/getLocalLocation']
            }

            return emp
        },

        installPWA() {
            window.deferredPrompt.prompt()
        },

        // Herramienta activa; el CSS .selected la muestra aunque no tenga narrow-tools-menu-visible
        isToolSelected(toolAction) {
            if (this.$route.name === 'ActionPlan') {
                return toolAction === '/audit'
            }

            if (toolAction === '/stock-pls') {
                return this.location === toolAction
            }
            if (toolAction === '/pls') {
                return this.location === toolAction
            }

            return this.location.indexOf(toolAction) > -1
        },

        isRadarTool(tool) {
            return tool.id === 'navRadar'
        },

        // Capa 1: decide si la herramienta se renderiza en el menú (rol, cuenta y feature flags)
        isMenuToolVisible(tool) {
            if (tool.type) {
                return false
            }

            if (this.isRadarTool(tool)) {
                return this.showRadarTool
            }

            return this.visibleTools.indexOf(Number(tool.code)) !== -1
        },

        // Capa 2: decide si la herramienta es visible en el menú lateral estrecho (narrow-tools-menu-visible)
        showInNarrowToolsMenu(tool) {
            // Radar siempre visible en menú estrecho
            if (this.showRadarTool && this.isRadarTool(tool)) {
                return true
            }

            return this.narrowToolsMenuIds.includes(tool.id)
        },
        // Visible en menú estrecho si cabe tras las herramientas Andy ya contabilizadas
        showExternalTool(tool, i) {
            return i + this.alexTools < this.toolsNumber
        },
        toggleMenu() {
            var self = this

            const isKitchenModeOn = this.$store.getters.isKitchenModeActive

            if (this.emp_id || isKitchenModeOn) {
                if (this.openedMenu) {
                    this.$store.commit('setMenuToolsExpanded', false)
                    this.$bar.show()
                    // this.$overlay.hide();
                } else {
                    this.$store.commit('setMenuToolsExpanded', true)
                    this.$bar.hide()
                    // this.$overlay.show({ loading: false, closable: false,
                    // callClick: function( popThis, popStore ){
                    // 	self.$store.commit('setMenuToolsExpanded', false);
                    // 	self.$overlay.hide();
                    // } });
                }
            } else {
                this.$popup.login({
                    list: this.$store.getters['employee/getLoginUsers'](0),
                    callAfterAccess: function (response) {
                        if (response) {
                            this.$popup.close()

                            const target = self.settingsAvailable ? '/config/location' : self.home
                            self.$router.push(self.$root.redirectPath(target)).catch((err) => {
                                if (err.name == 'NavigationDuplicated') {
                                    self.$router.push('/reset' + self.redirectPath(self.home))
                                }
                            })
                        }
                    }
                })
            }
        },
        navTool(action) {
            let self = this
            const isKitchenModeOn = self.$store.getters.isKitchenModeActive
            const kitchenHomeRoutes = ['/', '/home', '/chat', '/homewidgets']

            if (action.indexOf('/config') === 0 && !self.settingsAvailable) return

            if (self.$store.getters['hasAccess'](self.currentEmployee().id, 0) || action == '/release') {
                self.$router.push(self.redirectPath(action)).catch((err) => {
                    if (err && err.name == 'NavigationDuplicated') {
                        self.$router.push('/reset' + self.redirectPath(action))
                    }
                })
            } else if (isKitchenModeOn && !self.emp_id && kitchenHomeRoutes.includes(action)) {
                self.$router.push('/homewidgets')
            } else {
                const allowedRoutes = ['/traceability', '/timers', '/library', '/allergens', '/sensor', '/pls', '/homewidgets']

                if (allowedRoutes.includes(action)) {
                    self.$router.push(action)
                } else {
                    this.$popup.login({
                        list: this.$store.getters['employee/getLoginUsers'](0),
                        callAfterAccess: function (response) {
                            if (response) {
                                self.$router.push(self.redirectPath(action)).catch((err) => {
                                    if (err && err.name == 'NavigationDuplicated') {
                                        self.$router.go(self.$router.history.current)
                                    }
                                })
                                self.$popup.close()
                            }
                        }
                    })
                }
            }
        },
        navToolExternal(tool) {
            if (tool.type == 'url') {
                var hyperlink = tool.action.startsWith('www') ? 'https://' + tool.action : tool.action
                window.open(hyperlink, '_blank')
            } else if (this.isAPP) {
                window.plugins.launcher.canLaunch(
                    { packageName: tool.action },
                    function () {
                        window.plugins.launcher.launch({ packageName: tool.action })
                    },
                    function () {}
                )
            }
        },
        redirectPath(firstResult) {
            // let conn = this.$store.getters["getConnState"];

            //	POR QUE ENTRA EN BUCLE Ç¿¿¿??ÇÇ?
            // if ( firstResult == '/home' && !fnCheckConnection() ) {

            // 	this.$snackbar.offline({ message: this.$t('assets.no_signal') });
            // }
            return this.$root.redirectPath(firstResult)
        }
    },
    mounted() {
        let conn = fnCheckConnection()
        this.$store.commit('setConnState', conn)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$menu-size: 40px;
$alex-face: 70px;
$alex-body: 120px;

#menu-tools {
    transition-duration: 0s;
    position: fixed;
    bottom: $alex-app-padding;
    z-index: $z-menu-tools;
    width: calc(#{$menu-tools-min});
    height: calc(100% - (#{$alex-app-padding} * 2));

    .account {
        margin-top: 10px;
        @include display-flex();
        @include flex-direction(row);
        @include justify-content();
        @include align-items();
        @include flex-wrap(nowrap);
        position: fixed;
        width: 100%;
        top: 0px;
        right: -$menu-size;
        text-align: center;

        .avatar {
            display: inline-block;
            height: 30px;
            margin-right: 30px;
        }

        .name {
            @include background($size: 15px, $image: img('location_dark.svg'), $position: left center);
            @include font-size(ml);
            padding-left: 20px;
            color: #222;
            display: inline-block;
            width: fit-content;
            font-family: $text-bold;
            height: rem(30px);
            line-height: rem(30px);
        }
    }

    .alex-face {
        @include background($image: '', $size: $alex-face, $position: top left 10px);
        position: relative;
        cursor: pointer;
        left: -2px;
        height: $alex-face;
        display: block;

        &:hover {
            background-size: $alex-face + 3px;
        }
    }

    .menu-box {
        @include display-flex();
        @include align-items();
        @include justify-content(flex-start);
        @include flex-direction($dir: column);
        @include border-radius($default-border-radius);
        width: 100%;
        padding-right: 10px;
        height: calc(100% - #{$alex-face} - #{$alex-app-padding});
        overflow: auto;
        overflow-x: hidden;
    }

    .alex-body,
    .open-message,
    .ask-tool-message,
    .info,
    .helpcenter,
    .copyright,
    .expand-arrow {
        display: none;
    }

    .menu-list {
        @include display-flex();
        @include align-items(left);
        @include justify-content(top);
        @include flex-direction(column);
        overflow-y: auto;
        width: calc(100% + #{$alex-app-padding});
        height: calc(100% - 119px);
        padding-right: 7px;
        margin: 0;
        gap: 8px;

        .item {
            @include interaction();
            @include background($size: 35px, $position: top 6px left calc(50% + 3px));
            @include border-right-radius($default-border-radius);
            // Oculto por defecto en menú estrecho; solo .narrow-tools-menu-visible o .selected lo muestran
            display: none;
            // width: calc(100% + #{$alex-app-padding});
            width: 100%;
            min-width: $menu-size;
            max-height: rem(82px);

            &:hover {
                background-color: hover($default-bg-color);
            }

            .menu-tool-icon-wrapper {
                position: relative;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 36px;
                height: 36px;
                flex-shrink: 0;
            }

            .menu-tool-icon {
                color: #b5b2ab;
            }

            .radar-notification-badge {
                position: absolute;
                top: 5.947px;
                right: -3px;
                width: 12px;
                height: 12px;
                border-radius: 32px;
                background-color: $error-dark;
                pointer-events: none;
            }

            .external-tool-icon {
                width: $menu-size;
                height: $menu-size;
                background-size: 35px;
                background-repeat: no-repeat;
                background-position: center;
                flex-shrink: 0;
            }

            &.selected .menu-tool-icon {
                color: $color-white;
            }

            &.tool-item {
                @include flex-direction(column);
                @include align-items(center);
                background-image: none !important;
                gap: 4px;
                min-height: calc(25px + #{$menu-size});
            }

            .text {
                @include font-size(xs);
                font-family: $conden-medium;
                line-height: 1.1;
                color: #777672;
                text-align: center;
                display: inline-block;
                width: 90%;
                padding: 0 0 5px 6px;
                text-transform: uppercase;
                // height: auto;
                // max-height: 30px;

                // overflow: hidden;
                text-overflow: ellipsis;
                -webkit-line-clamp: 2;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                word-wrap: break-word;
                max-height: rem(40px);
            }

            .description {
                display: none;
            }

            // Ítem visible en el menú lateral estrecho (no aplica cuando está extendido)
            &.narrow-tools-menu-visible {
                @include display-flex();
                @include flex-direction(column);
                @include justify-content(center);
                @include align-items(center);
            }

            // Herramienta activa; siempre visible en menú estrecho
            &.selected {
                right: 6px;
                @include display-flex();
                @include flex-direction(column);
                @include justify-content(center);
                @include align-items(center);
                background-color: $main;

                .text {
                    color: white;
                }

                &:hover {
                    background-color: hover($main);
                }
            }

            .text-box {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                .text {
                    margin: 0px !important;
                    padding: 0px !important;
                }
            }
        }
    }

    .ticketing {
        @include interaction();
        @include background($size: 34px, $image: img('menu_help.svg'));
        @include interaction();
        // margin: 0 auto;
        width: calc(#{$menu-tools-min} - 12px);
        height: 30px;
        position: fixed;
        bottom: calc(25px * 2 + 40px);
        padding: 20px;
        left: 4px;
        margin: 0 auto;

        &:hover {
            background-image: img('menu_help_dark.svg');
        }

        &.selected {
            @include border-right-radius($default-border-radius);
            width: calc(#{$menu-tools-min} - 12px);
            left: 0;
            display: block;
            background-color: $main;
            background-image: img('menu_help_ffffff.svg');

            &:hover {
                background-color: hover($main);
            }
        }
    }

    .expand-tools {
        @include interaction();
        @include background($size: 40px, $image: img('menu_toggle.svg'));
        width: 40px;
        height: 40px;
        position: fixed;
        bottom: 25px;
        left: calc(#{$menu-tools-min}/ 4);

        &:hover {
            background-image: img('menu_toggle_dark.svg');
        }
    }

    #navTickets {
        background-image: img('menu_support_dark.svg');
        &.selected {
            background-image: img('menu_support_light.svg');
        }
    }

    #navRenew {
        background-image: img('renew.svg');
        &.selected {
            background-image: img('renew.svg');
        }
    }

    #navAlerts {
        display: flex !important;
        flex-direction: column;
        align-items: center;
        flex-wrap: nowrap;
        padding-top: 0 !important;
        gap: 5px;
        background-color: $error-light;

        i {
            color: $error-dark;
        }

        .text {
            color: $color-black;
        }
    }

    #navRelease {
        background-image: img('menu_release_dark.svg');

        &.selected {
            background-image: img('menu_release_light.svg');
        }
    }
}

.opened-menu #menu-tools {
    $copyright: 40px;

    @include box-shadow($h: 0px, $v: 0px, $b: 10px, $s: 0px, $c: rgba(100, 100, 100, 0.5));
    @include display-flex();
    @include align-items();
    border-radius: 8px;
    width: $menu-tools-max;
    background-color: $main;
    height: calc(90% - #{$copyright});
    width: 85%;
    margin: 0 auto;
    left: 7%;
    top: calc(5% + #{$copyright});
    transition: width 0.1s, height 0s;
    overflow: visible;

    @media (max-width: 1100px) {
        left: 4.6rem;
    }

    .alex-space {
        @include display-flex();
        @include justify-content(center);
        @include align-items(center);
        overflow: visible;
        width: 100%;
        position: absolute;
        top: -3.3rem;
        height: 120px;
        text-align: left;

        .alex-face {
            cursor: pointer;
            @include background($size: 117px, $position: bottom);
            display: inline-block;
            height: 120px;
            width: 120px;

            &:hover {
                background-size: 120px;
            }

            @media (min-width: 1300px) {
            }

            @media (max-width: 1000px) {
                background-size: 97px;

                &:hover {
                    background-size: 100px;
                }
            }
        }

        .open-message {
            text-overflow: ellipsis;
            display: inline-block;
            font-size: 2.5rem;
            font-family: $conden-bold;
            color: white;
            height: fit-content;
            margin-top: 65px;

            @media (min-width: 1300px) {
                font-size: 2.7rem;
            }

            @media (max-width: 1000px) {
                font-size: 2.3rem;
            }
        }
    }

    .menu-box {
        @include display-flex();
        @include flex-direction(column);
        @include align-items();
        @include justify-content();
        height: calc(100% - #{$alex-app-padding} - 55px);
        padding: 0;
        overflow-x: auto;
        margin-top: 35px;
    }

    .alex-body {
        @include background($image: img('alexpose_01.svg'), $size: $alex-body + 20px, $position: center);
        height: 100%;
        width: $alex-body;
        display: inline-block;
    }

    .ask-tool-message {
        @include font-size(l);
        font-family: $text;
        display: block;
        width: 100%;
        text-align: center;
        color: white;
        margin-top: 35px;
    }

    .menu-list {
        @include display-flex();
        @include flex-direction(row);
        @include flex-wrap(wrap);
        @include justify-content(center);
        @include align-items(center);
        @include align-content(flex-start);
        width: calc(100%);
        margin-top: 0;
        padding: 0;
        padding-top: 10px;
        height: calc(100% - (#{$alex-face} / 2));

        .item {
            @include box-shadow($h: 0px, $v: 0px, $b: 10px, $s: 0px, $c: rgba(45, 45, 45, 0.3));
            @include display-flex();
            // @include flex-direction(column);
            @include justify-content(center);
            @include align-items(center);
            background-color: $neutro-t50;
            min-width: rem(200px);
            width: calc(25% - 30px - 20px);
            max-width: rem(250px);
            // padding: 0px 9px 0px 60px;
            padding: 8px;
            min-height: 6rem;
            border-radius: 8px;
            gap: 8px;
            // @include background($size: 40px, $position: left 10px center);

            &.tool-item {
                display: flex !important;
                @include flex-direction(row);
                @include justify-content(flex-start);
                @include align-items(center);
                background-image: none !important;
                padding: 0 9px 0 10px;
                gap: 10px;

                .menu-tool-icon {
                    flex-shrink: 0;
                    color: $main;
                }

                .external-tool-icon {
                    width: 40px;
                    height: 40px;
                    background-size: 40px;
                }

                &.selected .menu-tool-icon {
                    color: $main;
                }
            }

            .text,
            .description {
                display: inline-block;
                width: 100%;
                text-align: left;
                color: inherit;
                text-transform: inherit;
                //
                // text-overflow: ellipsis;
                // -webkit-line-clamp: 2;
                // display: -webkit-box;
                // -webkit-box-orient: vertical;
                // word-wrap: break-word;
                // max-height: inherit;
            }

            .text {
                @include text-ellipsis();
                @include font-size(ml);
                // overflow: visible;
                font-family: $conden-bold;
                padding: 0;
                max-height: none;
                overflow-x: hidden;
            }

            .description {
                @include font-size(s);
                line-height: 1.1;
                font-family: $text-light;
                padding-top: 3px;
                word-break: keep-all;
            }

            &:hover {
                background-color: $neutro-t90;
                transform: translate(0, -6px);
            }
            &.selected {
                @include box-shadow($h: 0px, $v: 16px, $b: 12px, $s: 0px, $c: rgba(45, 45, 45, 0.3));
                transform: translate(0, -6px);
                background-color: #fff;
            }

            @media (min-width: 1300px) {
                margin-top: 20px;

                &.selected {
                    transform: translate(0, -12px);
                }
            }

            &#navTickets {
                background-image: img('menu_support.svg');
            }
            &#navRenew {
                background-image: img('renew.svg');
            }
            &#navAlerts {
                flex-direction: row;
                padding-left: 0px;
            }
            &#navRelease {
                background-image: img('menu_release.svg');
            }

        }
    }

    .info {
        display: block;
        position: absolute;
        bottom: 10px;
        left: 20px;
        color: $neutro-t90;
        text-decoration: underline;
        overflow: auto;
    }
    .helpcenter {
        @include background($image: img('question_f3f3f3.svg'), $size: 30px, $position: center right);
        padding-right: 43px;
        height: 35px;
        display: block;
        position: absolute;
        bottom: 5px;
        right: 5px;
        color: $main-s10;
        overflow: auto;

        .link {
            @include border-radius(3px);
            @include font-size(sm);
            background-color: #fff;
            height: 100%;
            display: inline-block;
            padding: 0 9px;
            position: relative;
            font-family: $conden-bold !important;
            text-decoration: underline;
            line-height: 35px;

            &:after {
                content: '';
                width: 0;
                height: 0;
                position: absolute;
                right: -6px;
                top: calc((35px / 2) - 6px);

                border-top: 6px solid transparent;
                border-bottom: 6px solid transparent;
                border-left: 6px solid #fff;
            }
        }
    }

    .copyright {
        display: block;
        bottom: 0;
        left: 0;
    }

    .expand-arrow {
        @include interaction();
        @include background($image: img('left_arrow_dark.svg'), $size: 30px, $color: #fff);
        @include border-radius(60px);
        width: 60px;
        height: 60px;
        position: fixed;
        left: calc(85% + 7% - 24px);
        top: calc(50% - 30px);
        display: block;

        &:hover {
            background-color: hover(#fff);
        }
    }

    .version {
        @include font-size(xs);
        position: fixed;
        bottom: $alex-app-padding;
        right: calc(3% + #{$alex-app-padding});
        text-align: right;
        width: 80px;
        color: $neutro-s20;
        font-family: $conden-light;
        padding: 0;
        margin: 0;
    }

    #navConfig {
        flex-direction: row;

        .menu-tool-icon {
            color: $main;
        }
    }
}

.offline #menu-tools {
    .alex-face {
        cursor: pointer;
        /*background-image: img("alexhead_04.svg") !important;*/
        // @include background($image: '', $size: 75px, $position: top left 0px);
        // background-image: url("data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='utf-8'?%3E%3C!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='330.078px' height='302px' viewBox='0 0 330.078 302' enable-background='new 0 0 330.078 302' xml:space='preserve'%3E%3Cellipse fill='%23ffffff' stroke='%23939292' stroke-width='6' stroke-miterlimit='10' cx='158.625' cy='179.022' rx='118.5' ry='117.973'/%3E%3Cpath fill='%23FFFFFF' d='M223.11,151.192c0,4.865-3.193,8.811-8.365,8.811c-5.174,0-8.367-3.945-8.367-8.811s3.193-8.811,8.367-8.811 C219.917,142.382,223.11,146.327,223.11,151.192z'/%3E%3Cpath fill='%23151415' d='M208.706,250.179c-0.336,11.417-11.674,20.348-18.426,20.148c-6.752-0.198-13.252-9.653-12.916-21.07 c0.336-11.418,7.381-20.475,14.133-20.275C198.249,229.18,209.042,238.761,208.706,250.179z'/%3E%3Cg%3E%3CradialGradient id='SVGID_1_' cx='190.4126' cy='155.3486' r='52.5898' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' style='stop-color:%2398D4C3'/%3E%3Cstop offset='1' style='stop-color:%23366960'/%3E%3C/radialGradient%3E%3Ccircle fill='url(%23SVGID_1_)' cx='190.413' cy='155.349' r='52.59'/%3E%3Cpath d='M216.37,152.561c0,13.482-11.621,24.417-25.953,24.417c-14.34,0-25.96-10.935-25.96-24.417 c0-13.486,11.62-24.416,25.96-24.416C204.749,128.145,216.37,139.074,216.37,152.561z'/%3E%3Cpath opacity='0.9' fill='%23FFFFFF' d='M218.012,163.589c0,4.832-4.164,8.748-9.299,8.748s-9.297-3.916-9.297-8.748 c0-4.826,4.162-8.742,9.297-8.742S218.012,158.763,218.012,163.589z'/%3E%3C/g%3E%3Cg%3E%3Cpath fill='%23806234' d='M47.751,166.691c-1.629,1.976-3.439,3.312-4.797,3.771c-10.507,3.556-5.645,1.222-19.688,3.932 c0,0-12.053-24.545-13.158-53.112C10.108,121.282,24.69,167.989,47.751,166.691L47.751,166.691z'/%3E%3Cpath fill='%23A28352' d='M47.751,166.691c7.116-8.634,15.703-28.243,15.703-28.243c5.891-11.717,12.204-22.283,19.197-31.607l0,0 c-9.309-4.18-22.001-6.012-25.307-29.271c-3.309-23.26,20.706-60.469,20.706-60.469C47.2,32.605,30.779,51.458,16.453,84.024 c-5.31,12.07-6.835,25.002-6.362,37.2C10.091,121.225,24.21,169.649,47.751,166.691L47.751,166.691z'/%3E%3Cpath fill='%23DCC59A' d='M77.862,17.267C94.997,8.655,123.972,4.774,145.37,6.104c0,0,31.312,2.906,43.05,21.776 c3.227,5.183-60.044,17.929-105.958,79.126C82.462,107.007,28.409,97.979,77.862,17.267'/%3E%3Cpath fill='%23A28352' d='M232.526,75.247c33.844,22.155,44.666,57.438,44.668,57.436c2.137-1.195,10.869-2.578,20.016-10.688l0,0 C312.096,37.55,259.268,7.089,259.268,7.089c-10.74-0.213-18.729-0.007-32.242,7.941C227.026,15.03,241.09,43.028,232.526,75.247z' /%3E%3Cpath fill='%23A28352' d='M297.209,121.995c-0.078,0.53,15.973-14.535,19.48-28.924c12.645-51.889-31.859-86.508-57.568-86.047 C259.122,7.024,309.803,38.821,297.209,121.995z'/%3E%3Cpath fill='%23A28352' d='M74.087,118.894c40.26-63.016,99.585-81.254,111.55-88.607l0.719-0.364c0,0,61.867-37.134,92.295-17.112 c0,0-7.363-5.248-20.572-5.781c-22.439-0.903-42.203,11.644-82.209,48.754l0,0c-5.844,5.424-12.146,11.398-18.984,17.975 c-53.644,51.584-82.126,45.506-82.126,45.506L74.087,118.894z'/%3E%3Cpath fill='%23806234' d='M74.958,118.003c0,0,52.613-59.367,103.931-84.303c1.807-0.879,3.326-1.43,5.145-2.508 c0,0-61.748,19.619-108.115,83.832C75.919,115.024,72.88,120.334,74.958,118.003z'/%3E%3Cpath fill='%23806234' d='M232.526,75.247c-15.539-9.794-30.17-16.921-55.031-20.838l1.039-1.218 c45.123-42.448,56.781-43.117,64.566-45.589c0,0,31.629,27.801-6.201,63.391L232.526,75.247z'/%3E%3C/g%3E%3C/svg%3E") !important;

        // Es una triquiñuela para precargar las imágenes que se usaen en OFFLINE
        // alexpose_04.svg, no_signal_alert.svg
        /*background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='720.072px' height='1332.133px' viewBox='0 0 720.072 1332.133' enable-background='new 0 0 720.072 1332.133' xml:space='preserve'%3E%3Cg%3E%3Cpath fill='%23283E92' d='M301.372,784.643'/%3E%3Cpath fill='%23283E92' d='M348.412,771.848c-11.584,101.281-32.358,158.221-50.04,216l5.778,212.918h-62.5 c-51.502-124.15-71.471-210.668-71.471-210.668c-18.283-41.137,68.168-587.688,117.127-630.416c6.875-6,30.512-7.992,54.503-8.355 l6.648,0.07c28.847-0.84,54.097,3.002,64.972,10.66c53.129,37.414,99.178,507.375,72.416,642.707l36.697,205l-89.031-0.332 l-75.332-186c-16.617-46.996-45.264-149.268-56.848-250.549'/%3E%3Cpath fill='none' stroke='%23101C3C' stroke-miterlimit='10' d='M325.191,903.807c-18.803-56.336-23.977-86.055-36.041-169.258'/%3E%3Cg%3E%3Cpath fill='%23A38452' d='M479.315,1236.78c0,0-92.5-35.5-99.787,22.264c-7.076,56.074,153.689,25.869,154.957,2.709 C536.726,1220.78,497.315,1225.963,479.315,1236.78z'/%3E%3Cpath fill='%23836336' d='M402.208,1229.479c0,0,31.949-12.102,77.107,7.301c10.051,4.318,18,8.75,28.5,18.75 C507.815,1255.53,441.065,1221.006,402.208,1229.479z'/%3E%3Cpath fill='%23836336' d='M379.528,1265.819c0,0,16.453,24.293,71.293,24.537C450.821,1290.356,385.649,1297.946,379.528,1265.819' /%3E%3C/g%3E%3Cg%3E%3Cpath fill='%23A38452' d='M260.469,1227.961c0,0-92.5-35.5-99.787,22.266c-7.076,56.074,153.689,25.869,154.957,2.709 C317.879,1211.961,278.469,1217.147,260.469,1227.961z'/%3E%3Cpath fill='%23836336' d='M183.362,1220.661c0,0,31.948-12.102,77.106,7.301c10.051,4.32,18,8.75,28.5,18.75 C288.969,1246.711,222.219,1212.19,183.362,1220.661z'/%3E%3Cpath fill='%23836336' d='M160.682,1257c0,0,16.453,24.295,71.293,24.539C231.975,1281.54,166.803,1289.127,160.682,1257'/%3E%3C/g%3E%3Cpath fill='%23E0E1E2' stroke='%237B7B7B' stroke-width='2' stroke-miterlimit='10' d='M201.365,493.661 c-0.861,5.021,1.263,11.533,4.383,19.404c5.963,15.049,10.908,23.131,21.621,41.467c0,0,0.799,24.664-8.075,45.445 c0,0-58.815-80.752-71.854-104.371c-5.468-9.904-2.122-19.775,5.21-31.842'/%3E%3Cpath fill='%23C6C6C5' d='M210.414,607.887c0,0,0.254,7.975,22.65,11.383c27.227,4.145,38.469-20.822,31.504-33.543 c-6.637-12.121-12.936-14.264-12.936-14.264s-21.686,1.154-7.055-7.406c11.525-6.744-23.426-16.043-24.953-9.209 C219.625,554.848,195.984,579.374,210.414,607.887z'/%3E%3Cpath fill='%23364D97' d='M205.607,492.782c2.274-10.713,18.541-25.203,18.541-25.203c14.184-12.324,30.511-33.986,30.511-33.986 c21.125-35.566,34.604-75.354,34.604-75.354c-1.859-0.645-14.339-0.188-28.72,8.229c-23.38,13.682-47.162,33.488-60.662,45.285 c-22.236,19.432-38.19,35.252-49.475,49.77c0,0-1.846,1.562,7.234,10.916C167.071,482.155,204.226,499.293,205.607,492.782z'/%3E%3Cpath fill='%23C58C7A' d='M395.56,355.067c0,0-6.254,25.365,11.949,99.719c0,0,26.068,81.691,61.4,83.691 c0,0,24.604,178.621,31.002,293.988c0,0-244.152,41.973-326.486-28.027c0,0,32.997-216.588,63.507-324.756 c0,0,26.558-85.248,50.916-120.666c0,0,4.084-2.834,9.857-3.746c0,0-16.707,31.826-19.754,70.039c0,0,28.896,15.791,87.558,4.711 c0,0,7.32-41.143,20.91-76.676C386.419,353.344,390.954,353.459,395.56,355.067z'/%3E%3Cpath fill='%2396685D' d='M242.323,569.04c0,0,38.518,20.275,115.852,8.943c0,0,9.587-3.117,10.292,3.441 c0.707,6.559-8.291,76.561,6.373,126.893c0,0,0,5.666-7.666,6.666c0,0-100.5,9.166-129-22.5c0,0-2.785-4.555-3.85-12.918 c-2.066-16.25-0.037-94.916,2.631-104.582C236.956,574.983,237.956,567.315,242.323,569.04z'/%3E%3Cpath fill='%23E0E1E2' stroke='%237B7B7B' stroke-width='2' stroke-miterlimit='10' d='M312.684,499.592 c-3.345-0.984-6.607-2.938-9.562-6.27c-12.548-14.145-28.03-35.611-58.462-72.924c0,0-20.27-12.58-47.602-10.887 c0,0,30.241,94.275,78.494,159.125c14.959,20.104,28.931,25.463,46.457,19.318'/%3E%3Cpath fill='%23364D97' d='M315.606,495.838c16.382,3.797,45.309-16.025,45.309-16.025c31.646-24.408,23.787-18.633,23.787-18.633 c9.207-146.051,61.045-93.148,61.045-93.148c8.471,8.908,22.484,27.242,8.98,105.133c-2.688,15.508-16.275,40.549-33.4,61.955 c-32.174,40.221-62.298,60.037-85.178,66.562c0,0-11.292-12.832-15.024-29.549C316.174,549.961,305.663,493.536,315.606,495.838z' /%3E%3Cpath fill='%23E0E1E2' stroke='%237B7B7B' stroke-width='2' stroke-miterlimit='10' d='M186.79,390.202c0,0-9.347-3.664-3.946-31.65 c6.564-34.021,40.899-36.822,53.043-23.203c11.572,12.977,11.455,21.346,11.455,21.346s-10.512,25.219,5.807,11.486 c12.854-10.82,9.143,34.531,0.396,33.461C253.545,401.641,214.508,419.325,186.79,390.202z'/%3E%3Cellipse fill='%23FFFFFF' stroke='%23939393' stroke-width='7' stroke-miterlimit='10' cx='332.884' cy='214.172' rx='118.5' ry='117.973'/%3E%3Cpath fill='%23FFFFFF' d='M268.397,186.342c0,4.865,3.193,8.811,8.365,8.811c5.174,0,8.367-3.945,8.367-8.811 c0-4.867-3.193-8.811-8.367-8.811C271.591,177.532,268.397,181.475,268.397,186.342z'/%3E%3Cpath fill='%23151515' d='M282.802,285.327c0.336,11.418,11.674,20.348,18.428,20.15c6.75-0.199,13.252-9.654,12.916-21.072 c-0.337-11.416-7.381-20.475-14.133-20.275C293.26,264.329,282.466,273.911,282.802,285.327z'/%3E%3Cg%3E%3CradialGradient id='SVGID_1_' cx='3431.2637' cy='190.4976' r='52.5908' gradientTransform='matrix(-1 0 0 1 3732.3594 0)' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' style='stop-color:%2399D4C3'/%3E%3Cstop offset='1' style='stop-color:%23366960'/%3E%3C/radialGradient%3E%3Cpath fill='url(%23SVGID_1_)' d='M353.687,190.497c0,29.047-23.546,52.592-52.594,52.592c-29.041,0-52.588-23.545-52.588-52.592 c0-29.043,23.547-52.59,52.588-52.59C330.141,137.907,353.687,161.454,353.687,190.497z'/%3E%3Cpath d='M275.14,187.709c0,13.482,11.62,24.416,25.952,24.416c14.341,0,25.96-10.934,25.96-24.416 c0-13.486-11.619-24.416-25.96-24.416C286.76,163.293,275.14,174.223,275.14,187.709z'/%3E%3Cellipse opacity='0.9' fill='%23FFFFFF' cx='282.794' cy='198.739' rx='9.297' ry='8.746'/%3E%3C/g%3E%3Cg%3E%3Cpath fill='%23806134' d='M443.759,201.84c1.629,1.977,3.439,3.311,4.795,3.771c10.506,3.557,5.646,1.221,19.688,3.932 c0,0,12.055-24.545,13.16-53.113C481.401,156.43,466.817,203.139,443.759,201.84L443.759,201.84z'/%3E%3Cpath fill='%23A38452' d='M443.759,201.84c-7.119-8.633-15.703-28.242-15.703-28.242c-5.893-11.717-12.205-22.285-19.199-31.607l0,0 c9.311-4.182,22.002-6.012,25.309-29.271c3.307-23.262-20.707-60.471-20.707-60.471c30.85,15.506,47.271,34.357,61.598,66.924 c5.311,12.07,6.832,25.002,6.363,37.201C481.419,156.374,467.3,204.797,443.759,201.84L443.759,201.84z'/%3E%3Cpath fill='%23DDC59B' d='M413.646,52.415c-17.133-8.609-46.107-12.492-67.507-11.162c0,0-31.312,2.908-43.051,21.777 c-3.225,5.184,60.047,17.93,105.961,79.127C409.048,142.157,463.101,133.127,413.646,52.415'/%3E%3Cpath fill='%23A38452' d='M258.983,110.395c-33.844,22.156-44.668,57.438-44.668,57.438c-2.137-1.195-10.869-2.58-20.018-10.688l0,0 C179.413,72.7,232.241,42.239,232.241,42.239c10.74-0.215,18.729-0.008,32.242,7.939 C264.483,50.178,250.417,78.176,258.983,110.395z'/%3E%3Cpath fill='%23A38452' d='M194.298,157.145c0.078,0.529-15.973-14.537-19.479-28.926c-12.645-51.889,31.859-86.506,57.566-86.045 C232.386,42.174,181.704,73.971,194.298,157.145z'/%3E%3Cpath fill='%23A38452' d='M417.423,154.043c-40.26-63.016-99.588-81.256-111.551-88.607l-0.721-0.365 c0,0-61.865-37.135-92.293-17.111c0,0,7.361-5.25,20.572-5.781c22.439-0.904,42.203,11.643,82.207,48.754l0,0 c5.846,5.422,12.146,11.396,18.986,17.973c53.645,51.584,82.125,45.506,82.125,45.506L417.423,154.043z'/%3E%3Cpath fill='%23806134' d='M416.552,153.153c0,0-52.615-59.369-103.934-84.305c-1.805-0.879-3.326-1.43-5.143-2.508 c0,0,61.748,19.621,108.115,83.834C415.591,150.174,418.626,155.483,416.552,153.153z'/%3E%3Cpath fill='%23806134' d='M258.983,110.395c15.537-9.793,30.17-16.92,55.031-20.836l-1.039-1.219 c-45.125-42.449-56.782-43.117-64.569-45.588c0,0-31.626,27.801,6.203,63.391L258.983,110.395z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A"),
      url("data:image/svg+xml,%3C%3Fxml version='1.0'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Capa_1' x='0px' y='0px' viewBox='0 0 512.023 512.023' style='enable-background:new 0 0 512.023 512.023;' xml:space='preserve' width='512px' height='512px'%3E%3Cg%3E%3Cg%3E%3Cg%3E%3Cpath d='M507.343,484.687l-480-480c-6.24-6.24-16.384-6.24-22.624,0c-6.24,6.24-6.24,16.384,0,22.624l49.536,49.536 c-15.904,7.328-31.52,15.264-46.56,24.384c-3.648,2.208-6.272,5.824-7.264,9.984c-0.992,4.16-0.256,8.576,2.048,12.192 l42.784,67.968c25.536-16.832,53.28-30.528,82.528-40.96l25.472,25.472c-32.512,9.952-63.2,24.128-90.976,42.528l34.048,54.08 c32.64-21.824,70.272-36.192,110.464-43.072l28.16,28.16c-44.672,3.68-86.336,18.208-121.6,41.952l34.144,54.208 c30.912-21.216,68.256-33.728,108.512-33.728c16.48,0,32.384,2.304,47.616,6.24l181.056,181.056 c3.136,3.136,7.232,4.704,11.328,4.704s8.192-1.568,11.328-4.672C513.583,501.071,513.583,490.959,507.343,484.687z' data-original='%23000000' class='active-path' data-old_color='%23e55d5c' fill='%23e55d5c'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cpath d='M511.567,111.247c-0.96-4.16-3.584-7.776-7.264-10.016c-74.528-45.28-160.416-69.216-248.288-69.216 c-46.464,0-92.32,6.88-136.256,19.872l80.256,80.256c18.304-2.688,36.992-4.128,56-4.128c77.824,0,150.176,23.424,210.752,63.36 l42.784-67.936C511.823,119.791,512.591,115.408,511.567,111.247z' data-original='%23000000' class='active-path' data-old_color='%23e55d5c' fill='%23e55d5c'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cpath d='M256.015,160.015c-9.12,0-18.144,0.352-27.072,1.056l65.888,65.888c44.224,6.016,85.344,21.792,120.864,45.568 l34.048-54.112C394.127,181.583,327.567,160.015,256.015,160.015z' data-original='%23000000' class='active-path' data-old_color='%23e55d5c' fill='%23e55d5c'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cpath d='M337.647,269.775l48.928,48.928l12.064-19.168C379.951,286.959,359.375,277.103,337.647,269.775z' data-original='%23000000' class='active-path' data-old_color='%23e55d5c' fill='%23e55d5c'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cpath d='M256.015,352.015c-33.984,0-65.408,10.816-91.36,28.992l77.792,123.552c2.944,4.64,8.064,7.456,13.568,7.456 c5.504,0,10.624-2.816,13.536-7.456l77.792-123.552C321.423,362.831,289.999,352.015,256.015,352.015z' data-original='%23000000' class='active-path' data-old_color='%23e55d5c' fill='%23e55d5c'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A");
    background-size: 110px, 30px;
    background-position: top 15px left 5px, top 20px left 0px;*/
        // &:after {
        //     content: '';
        //     @include background($size: 25px);
        //     background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Capa_1' x='0px' y='0px' viewBox='0 0 512.023 512.023' style='enable-background:new 0 0 512.023 512.023;' xml:space='preserve' width='512px' height='512px'%3E%3Cg%3E%3Cg%3E%3Cg%3E%3Cpath d='M507.343,484.687l-480-480c-6.24-6.24-16.384-6.24-22.624,0c-6.24,6.24-6.24,16.384,0,22.624l49.536,49.536 c-15.904,7.328-31.52,15.264-46.56,24.384c-3.648,2.208-6.272,5.824-7.264,9.984c-0.992,4.16-0.256,8.576,2.048,12.192 l42.784,67.968c25.536-16.832,53.28-30.528,82.528-40.96l25.472,25.472c-32.512,9.952-63.2,24.128-90.976,42.528l34.048,54.08 c32.64-21.824,70.272-36.192,110.464-43.072l28.16,28.16c-44.672,3.68-86.336,18.208-121.6,41.952l34.144,54.208 c30.912-21.216,68.256-33.728,108.512-33.728c16.48,0,32.384,2.304,47.616,6.24l181.056,181.056 c3.136,3.136,7.232,4.704,11.328,4.704s8.192-1.568,11.328-4.672C513.583,501.071,513.583,490.959,507.343,484.687z' data-original='%23000000' class='active-path' data-old_color='%23e55d5c' fill='%23e55d5c'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cpath d='M511.567,111.247c-0.96-4.16-3.584-7.776-7.264-10.016c-74.528-45.28-160.416-69.216-248.288-69.216 c-46.464,0-92.32,6.88-136.256,19.872l80.256,80.256c18.304-2.688,36.992-4.128,56-4.128c77.824,0,150.176,23.424,210.752,63.36 l42.784-67.936C511.823,119.791,512.591,115.408,511.567,111.247z' data-original='%23000000' class='active-path' data-old_color='%23e55d5c' fill='%23e55d5c'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cpath d='M256.015,160.015c-9.12,0-18.144,0.352-27.072,1.056l65.888,65.888c44.224,6.016,85.344,21.792,120.864,45.568 l34.048-54.112C394.127,181.583,327.567,160.015,256.015,160.015z' data-original='%23000000' class='active-path' data-old_color='%23e55d5c' fill='%23e55d5c'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cpath d='M337.647,269.775l48.928,48.928l12.064-19.168C379.951,286.959,359.375,277.103,337.647,269.775z' data-original='%23000000' class='active-path' data-old_color='%23e55d5c' fill='%23e55d5c'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cpath d='M256.015,352.015c-33.984,0-65.408,10.816-91.36,28.992l77.792,123.552c2.944,4.64,8.064,7.456,13.568,7.456 c5.504,0,10.624-2.816,13.536-7.456l77.792-123.552C321.423,362.831,289.999,352.015,256.015,352.015z' data-original='%23000000' class='active-path' data-old_color='%23e55d5c' fill='%23e55d5c'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A");
        //     margin-left: 15px;
        //     width: 40px;
        //     height: 40px;
        //     display: inline-block;
        //     position: absolute;
        //     right: -20px;
        //     top: 10px;
        // }
    }
}

.offline.opened-menu #menu-tools {
    .alex-face {
        cursor: pointer;
        width: 160px;
        // @include background($image: '', $size: 120px, $position: right 40px center);
        // background-image: url("data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='utf-8'?%3E%3C!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='330.078px' height='302px' viewBox='0 0 330.078 302' enable-background='new 0 0 330.078 302' xml:space='preserve'%3E%3Cellipse fill='%23ffffff' stroke='%23939292' stroke-width='6' stroke-miterlimit='10' cx='158.625' cy='179.022' rx='118.5' ry='117.973'/%3E%3Cpath fill='%23FFFFFF' d='M223.11,151.192c0,4.865-3.193,8.811-8.365,8.811c-5.174,0-8.367-3.945-8.367-8.811s3.193-8.811,8.367-8.811 C219.917,142.382,223.11,146.327,223.11,151.192z'/%3E%3Cpath fill='%23151415' d='M208.706,250.179c-0.336,11.417-11.674,20.348-18.426,20.148c-6.752-0.198-13.252-9.653-12.916-21.07 c0.336-11.418,7.381-20.475,14.133-20.275C198.249,229.18,209.042,238.761,208.706,250.179z'/%3E%3Cg%3E%3CradialGradient id='SVGID_1_' cx='190.4126' cy='155.3486' r='52.5898' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' style='stop-color:%2398D4C3'/%3E%3Cstop offset='1' style='stop-color:%23366960'/%3E%3C/radialGradient%3E%3Ccircle fill='url(%23SVGID_1_)' cx='190.413' cy='155.349' r='52.59'/%3E%3Cpath d='M216.37,152.561c0,13.482-11.621,24.417-25.953,24.417c-14.34,0-25.96-10.935-25.96-24.417 c0-13.486,11.62-24.416,25.96-24.416C204.749,128.145,216.37,139.074,216.37,152.561z'/%3E%3Cpath opacity='0.9' fill='%23FFFFFF' d='M218.012,163.589c0,4.832-4.164,8.748-9.299,8.748s-9.297-3.916-9.297-8.748 c0-4.826,4.162-8.742,9.297-8.742S218.012,158.763,218.012,163.589z'/%3E%3C/g%3E%3Cg%3E%3Cpath fill='%23806234' d='M47.751,166.691c-1.629,1.976-3.439,3.312-4.797,3.771c-10.507,3.556-5.645,1.222-19.688,3.932 c0,0-12.053-24.545-13.158-53.112C10.108,121.282,24.69,167.989,47.751,166.691L47.751,166.691z'/%3E%3Cpath fill='%23A28352' d='M47.751,166.691c7.116-8.634,15.703-28.243,15.703-28.243c5.891-11.717,12.204-22.283,19.197-31.607l0,0 c-9.309-4.18-22.001-6.012-25.307-29.271c-3.309-23.26,20.706-60.469,20.706-60.469C47.2,32.605,30.779,51.458,16.453,84.024 c-5.31,12.07-6.835,25.002-6.362,37.2C10.091,121.225,24.21,169.649,47.751,166.691L47.751,166.691z'/%3E%3Cpath fill='%23DCC59A' d='M77.862,17.267C94.997,8.655,123.972,4.774,145.37,6.104c0,0,31.312,2.906,43.05,21.776 c3.227,5.183-60.044,17.929-105.958,79.126C82.462,107.007,28.409,97.979,77.862,17.267'/%3E%3Cpath fill='%23A28352' d='M232.526,75.247c33.844,22.155,44.666,57.438,44.668,57.436c2.137-1.195,10.869-2.578,20.016-10.688l0,0 C312.096,37.55,259.268,7.089,259.268,7.089c-10.74-0.213-18.729-0.007-32.242,7.941C227.026,15.03,241.09,43.028,232.526,75.247z' /%3E%3Cpath fill='%23A28352' d='M297.209,121.995c-0.078,0.53,15.973-14.535,19.48-28.924c12.645-51.889-31.859-86.508-57.568-86.047 C259.122,7.024,309.803,38.821,297.209,121.995z'/%3E%3Cpath fill='%23A28352' d='M74.087,118.894c40.26-63.016,99.585-81.254,111.55-88.607l0.719-0.364c0,0,61.867-37.134,92.295-17.112 c0,0-7.363-5.248-20.572-5.781c-22.439-0.903-42.203,11.644-82.209,48.754l0,0c-5.844,5.424-12.146,11.398-18.984,17.975 c-53.644,51.584-82.126,45.506-82.126,45.506L74.087,118.894z'/%3E%3Cpath fill='%23806234' d='M74.958,118.003c0,0,52.613-59.367,103.931-84.303c1.807-0.879,3.326-1.43,5.145-2.508 c0,0-61.748,19.619-108.115,83.832C75.919,115.024,72.88,120.334,74.958,118.003z'/%3E%3Cpath fill='%23806234' d='M232.526,75.247c-15.539-9.794-30.17-16.921-55.031-20.838l1.039-1.218 c45.123-42.448,56.781-43.117,64.566-45.589c0,0,31.629,27.801-6.201,63.391L232.526,75.247z'/%3E%3C/g%3E%3C/svg%3E") !important;
        // &:after {
        //     content: '';
        //     @include background($size: 40px);
        //     background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Capa_1' x='0px' y='0px' viewBox='0 0 512.023 512.023' style='enable-background:new 0 0 512.023 512.023;' xml:space='preserve' width='512px' height='512px'%3E%3Cg%3E%3Cg%3E%3Cg%3E%3Cpath d='M507.343,484.687l-480-480c-6.24-6.24-16.384-6.24-22.624,0c-6.24,6.24-6.24,16.384,0,22.624l49.536,49.536 c-15.904,7.328-31.52,15.264-46.56,24.384c-3.648,2.208-6.272,5.824-7.264,9.984c-0.992,4.16-0.256,8.576,2.048,12.192 l42.784,67.968c25.536-16.832,53.28-30.528,82.528-40.96l25.472,25.472c-32.512,9.952-63.2,24.128-90.976,42.528l34.048,54.08 c32.64-21.824,70.272-36.192,110.464-43.072l28.16,28.16c-44.672,3.68-86.336,18.208-121.6,41.952l34.144,54.208 c30.912-21.216,68.256-33.728,108.512-33.728c16.48,0,32.384,2.304,47.616,6.24l181.056,181.056 c3.136,3.136,7.232,4.704,11.328,4.704s8.192-1.568,11.328-4.672C513.583,501.071,513.583,490.959,507.343,484.687z' data-original='%23000000' class='active-path' data-old_color='%23e55d5c' fill='%23e55d5c'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cpath d='M511.567,111.247c-0.96-4.16-3.584-7.776-7.264-10.016c-74.528-45.28-160.416-69.216-248.288-69.216 c-46.464,0-92.32,6.88-136.256,19.872l80.256,80.256c18.304-2.688,36.992-4.128,56-4.128c77.824,0,150.176,23.424,210.752,63.36 l42.784-67.936C511.823,119.791,512.591,115.408,511.567,111.247z' data-original='%23000000' class='active-path' data-old_color='%23e55d5c' fill='%23e55d5c'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cpath d='M256.015,160.015c-9.12,0-18.144,0.352-27.072,1.056l65.888,65.888c44.224,6.016,85.344,21.792,120.864,45.568 l34.048-54.112C394.127,181.583,327.567,160.015,256.015,160.015z' data-original='%23000000' class='active-path' data-old_color='%23e55d5c' fill='%23e55d5c'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cpath d='M337.647,269.775l48.928,48.928l12.064-19.168C379.951,286.959,359.375,277.103,337.647,269.775z' data-original='%23000000' class='active-path' data-old_color='%23e55d5c' fill='%23e55d5c'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cpath d='M256.015,352.015c-33.984,0-65.408,10.816-91.36,28.992l77.792,123.552c2.944,4.64,8.064,7.456,13.568,7.456 c5.504,0,10.624-2.816,13.536-7.456l77.792-123.552C321.423,362.831,289.999,352.015,256.015,352.015z' data-original='%23000000' class='active-path' data-old_color='%23e55d5c' fill='%23e55d5c'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A");
        //     margin-left: 15px;
        //     width: 40px;
        //     height: 40px;
        //     display: inline-block;
        //     position: absolute;
        //     right: 10px;
        //     top: calc(55%);
        // }
    }
    .alex-body {
        // alexpose_04.svg
        background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='720.072px' height='1332.133px' viewBox='0 0 720.072 1332.133' enable-background='new 0 0 720.072 1332.133' xml:space='preserve'%3E%3Cg%3E%3Cpath fill='%23283E92' d='M301.372,784.643'/%3E%3Cpath fill='%23283E92' d='M348.412,771.848c-11.584,101.281-32.358,158.221-50.04,216l5.778,212.918h-62.5 c-51.502-124.15-71.471-210.668-71.471-210.668c-18.283-41.137,68.168-587.688,117.127-630.416c6.875-6,30.512-7.992,54.503-8.355 l6.648,0.07c28.847-0.84,54.097,3.002,64.972,10.66c53.129,37.414,99.178,507.375,72.416,642.707l36.697,205l-89.031-0.332 l-75.332-186c-16.617-46.996-45.264-149.268-56.848-250.549'/%3E%3Cpath fill='none' stroke='%23101C3C' stroke-miterlimit='10' d='M325.191,903.807c-18.803-56.336-23.977-86.055-36.041-169.258'/%3E%3Cg%3E%3Cpath fill='%23A38452' d='M479.315,1236.78c0,0-92.5-35.5-99.787,22.264c-7.076,56.074,153.689,25.869,154.957,2.709 C536.726,1220.78,497.315,1225.963,479.315,1236.78z'/%3E%3Cpath fill='%23836336' d='M402.208,1229.479c0,0,31.949-12.102,77.107,7.301c10.051,4.318,18,8.75,28.5,18.75 C507.815,1255.53,441.065,1221.006,402.208,1229.479z'/%3E%3Cpath fill='%23836336' d='M379.528,1265.819c0,0,16.453,24.293,71.293,24.537C450.821,1290.356,385.649,1297.946,379.528,1265.819' /%3E%3C/g%3E%3Cg%3E%3Cpath fill='%23A38452' d='M260.469,1227.961c0,0-92.5-35.5-99.787,22.266c-7.076,56.074,153.689,25.869,154.957,2.709 C317.879,1211.961,278.469,1217.147,260.469,1227.961z'/%3E%3Cpath fill='%23836336' d='M183.362,1220.661c0,0,31.948-12.102,77.106,7.301c10.051,4.32,18,8.75,28.5,18.75 C288.969,1246.711,222.219,1212.19,183.362,1220.661z'/%3E%3Cpath fill='%23836336' d='M160.682,1257c0,0,16.453,24.295,71.293,24.539C231.975,1281.54,166.803,1289.127,160.682,1257'/%3E%3C/g%3E%3Cpath fill='%23E0E1E2' stroke='%237B7B7B' stroke-width='2' stroke-miterlimit='10' d='M201.365,493.661 c-0.861,5.021,1.263,11.533,4.383,19.404c5.963,15.049,10.908,23.131,21.621,41.467c0,0,0.799,24.664-8.075,45.445 c0,0-58.815-80.752-71.854-104.371c-5.468-9.904-2.122-19.775,5.21-31.842'/%3E%3Cpath fill='%23C6C6C5' d='M210.414,607.887c0,0,0.254,7.975,22.65,11.383c27.227,4.145,38.469-20.822,31.504-33.543 c-6.637-12.121-12.936-14.264-12.936-14.264s-21.686,1.154-7.055-7.406c11.525-6.744-23.426-16.043-24.953-9.209 C219.625,554.848,195.984,579.374,210.414,607.887z'/%3E%3Cpath fill='%23364D97' d='M205.607,492.782c2.274-10.713,18.541-25.203,18.541-25.203c14.184-12.324,30.511-33.986,30.511-33.986 c21.125-35.566,34.604-75.354,34.604-75.354c-1.859-0.645-14.339-0.188-28.72,8.229c-23.38,13.682-47.162,33.488-60.662,45.285 c-22.236,19.432-38.19,35.252-49.475,49.77c0,0-1.846,1.562,7.234,10.916C167.071,482.155,204.226,499.293,205.607,492.782z'/%3E%3Cpath fill='%23C58C7A' d='M395.56,355.067c0,0-6.254,25.365,11.949,99.719c0,0,26.068,81.691,61.4,83.691 c0,0,24.604,178.621,31.002,293.988c0,0-244.152,41.973-326.486-28.027c0,0,32.997-216.588,63.507-324.756 c0,0,26.558-85.248,50.916-120.666c0,0,4.084-2.834,9.857-3.746c0,0-16.707,31.826-19.754,70.039c0,0,28.896,15.791,87.558,4.711 c0,0,7.32-41.143,20.91-76.676C386.419,353.344,390.954,353.459,395.56,355.067z'/%3E%3Cpath fill='%2396685D' d='M242.323,569.04c0,0,38.518,20.275,115.852,8.943c0,0,9.587-3.117,10.292,3.441 c0.707,6.559-8.291,76.561,6.373,126.893c0,0,0,5.666-7.666,6.666c0,0-100.5,9.166-129-22.5c0,0-2.785-4.555-3.85-12.918 c-2.066-16.25-0.037-94.916,2.631-104.582C236.956,574.983,237.956,567.315,242.323,569.04z'/%3E%3Cpath fill='%23E0E1E2' stroke='%237B7B7B' stroke-width='2' stroke-miterlimit='10' d='M312.684,499.592 c-3.345-0.984-6.607-2.938-9.562-6.27c-12.548-14.145-28.03-35.611-58.462-72.924c0,0-20.27-12.58-47.602-10.887 c0,0,30.241,94.275,78.494,159.125c14.959,20.104,28.931,25.463,46.457,19.318'/%3E%3Cpath fill='%23364D97' d='M315.606,495.838c16.382,3.797,45.309-16.025,45.309-16.025c31.646-24.408,23.787-18.633,23.787-18.633 c9.207-146.051,61.045-93.148,61.045-93.148c8.471,8.908,22.484,27.242,8.98,105.133c-2.688,15.508-16.275,40.549-33.4,61.955 c-32.174,40.221-62.298,60.037-85.178,66.562c0,0-11.292-12.832-15.024-29.549C316.174,549.961,305.663,493.536,315.606,495.838z' /%3E%3Cpath fill='%23E0E1E2' stroke='%237B7B7B' stroke-width='2' stroke-miterlimit='10' d='M186.79,390.202c0,0-9.347-3.664-3.946-31.65 c6.564-34.021,40.899-36.822,53.043-23.203c11.572,12.977,11.455,21.346,11.455,21.346s-10.512,25.219,5.807,11.486 c12.854-10.82,9.143,34.531,0.396,33.461C253.545,401.641,214.508,419.325,186.79,390.202z'/%3E%3Cellipse fill='%23FFFFFF' stroke='%23939393' stroke-width='7' stroke-miterlimit='10' cx='332.884' cy='214.172' rx='118.5' ry='117.973'/%3E%3Cpath fill='%23FFFFFF' d='M268.397,186.342c0,4.865,3.193,8.811,8.365,8.811c5.174,0,8.367-3.945,8.367-8.811 c0-4.867-3.193-8.811-8.367-8.811C271.591,177.532,268.397,181.475,268.397,186.342z'/%3E%3Cpath fill='%23151515' d='M282.802,285.327c0.336,11.418,11.674,20.348,18.428,20.15c6.75-0.199,13.252-9.654,12.916-21.072 c-0.337-11.416-7.381-20.475-14.133-20.275C293.26,264.329,282.466,273.911,282.802,285.327z'/%3E%3Cg%3E%3CradialGradient id='SVGID_1_' cx='3431.2637' cy='190.4976' r='52.5908' gradientTransform='matrix(-1 0 0 1 3732.3594 0)' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' style='stop-color:%2399D4C3'/%3E%3Cstop offset='1' style='stop-color:%23366960'/%3E%3C/radialGradient%3E%3Cpath fill='url(%23SVGID_1_)' d='M353.687,190.497c0,29.047-23.546,52.592-52.594,52.592c-29.041,0-52.588-23.545-52.588-52.592 c0-29.043,23.547-52.59,52.588-52.59C330.141,137.907,353.687,161.454,353.687,190.497z'/%3E%3Cpath d='M275.14,187.709c0,13.482,11.62,24.416,25.952,24.416c14.341,0,25.96-10.934,25.96-24.416 c0-13.486-11.619-24.416-25.96-24.416C286.76,163.293,275.14,174.223,275.14,187.709z'/%3E%3Cellipse opacity='0.9' fill='%23FFFFFF' cx='282.794' cy='198.739' rx='9.297' ry='8.746'/%3E%3C/g%3E%3Cg%3E%3Cpath fill='%23806134' d='M443.759,201.84c1.629,1.977,3.439,3.311,4.795,3.771c10.506,3.557,5.646,1.221,19.688,3.932 c0,0,12.055-24.545,13.16-53.113C481.401,156.43,466.817,203.139,443.759,201.84L443.759,201.84z'/%3E%3Cpath fill='%23A38452' d='M443.759,201.84c-7.119-8.633-15.703-28.242-15.703-28.242c-5.893-11.717-12.205-22.285-19.199-31.607l0,0 c9.311-4.182,22.002-6.012,25.309-29.271c3.307-23.262-20.707-60.471-20.707-60.471c30.85,15.506,47.271,34.357,61.598,66.924 c5.311,12.07,6.832,25.002,6.363,37.201C481.419,156.374,467.3,204.797,443.759,201.84L443.759,201.84z'/%3E%3Cpath fill='%23DDC59B' d='M413.646,52.415c-17.133-8.609-46.107-12.492-67.507-11.162c0,0-31.312,2.908-43.051,21.777 c-3.225,5.184,60.047,17.93,105.961,79.127C409.048,142.157,463.101,133.127,413.646,52.415'/%3E%3Cpath fill='%23A38452' d='M258.983,110.395c-33.844,22.156-44.668,57.438-44.668,57.438c-2.137-1.195-10.869-2.58-20.018-10.688l0,0 C179.413,72.7,232.241,42.239,232.241,42.239c10.74-0.215,18.729-0.008,32.242,7.939 C264.483,50.178,250.417,78.176,258.983,110.395z'/%3E%3Cpath fill='%23A38452' d='M194.298,157.145c0.078,0.529-15.973-14.537-19.479-28.926c-12.645-51.889,31.859-86.506,57.566-86.045 C232.386,42.174,181.704,73.971,194.298,157.145z'/%3E%3Cpath fill='%23A38452' d='M417.423,154.043c-40.26-63.016-99.588-81.256-111.551-88.607l-0.721-0.365 c0,0-61.865-37.135-92.293-17.111c0,0,7.361-5.25,20.572-5.781c22.439-0.904,42.203,11.643,82.207,48.754l0,0 c5.846,5.422,12.146,11.396,18.986,17.973c53.645,51.584,82.125,45.506,82.125,45.506L417.423,154.043z'/%3E%3Cpath fill='%23806134' d='M416.552,153.153c0,0-52.615-59.369-103.934-84.305c-1.805-0.879-3.326-1.43-5.143-2.508 c0,0,61.748,19.621,108.115,83.834C415.591,150.174,418.626,155.483,416.552,153.153z'/%3E%3Cpath fill='%23806134' d='M258.983,110.395c15.537-9.793,30.17-16.92,55.031-20.836l-1.039-1.219 c-45.125-42.449-56.782-43.117-64.569-45.588c0,0-31.626,27.801,6.203,63.391L258.983,110.395z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A");
        background-position: center bottom 5%;

        .alert {
            @include background($size: 30px, $position: top 6px center);
            background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Capa_1' x='0px' y='0px' viewBox='0 0 512.023 512.023' style='enable-background:new 0 0 512.023 512.023;' xml:space='preserve' width='512px' height='512px'%3E%3Cg%3E%3Cg%3E%3Cg%3E%3Cpath d='M507.343,484.687l-480-480c-6.24-6.24-16.384-6.24-22.624,0c-6.24,6.24-6.24,16.384,0,22.624l49.536,49.536 c-15.904,7.328-31.52,15.264-46.56,24.384c-3.648,2.208-6.272,5.824-7.264,9.984c-0.992,4.16-0.256,8.576,2.048,12.192 l42.784,67.968c25.536-16.832,53.28-30.528,82.528-40.96l25.472,25.472c-32.512,9.952-63.2,24.128-90.976,42.528l34.048,54.08 c32.64-21.824,70.272-36.192,110.464-43.072l28.16,28.16c-44.672,3.68-86.336,18.208-121.6,41.952l34.144,54.208 c30.912-21.216,68.256-33.728,108.512-33.728c16.48,0,32.384,2.304,47.616,6.24l181.056,181.056 c3.136,3.136,7.232,4.704,11.328,4.704s8.192-1.568,11.328-4.672C513.583,501.071,513.583,490.959,507.343,484.687z' data-original='%23000000' class='active-path' data-old_color='%23e55d5c' fill='%23e55d5c'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cpath d='M511.567,111.247c-0.96-4.16-3.584-7.776-7.264-10.016c-74.528-45.28-160.416-69.216-248.288-69.216 c-46.464,0-92.32,6.88-136.256,19.872l80.256,80.256c18.304-2.688,36.992-4.128,56-4.128c77.824,0,150.176,23.424,210.752,63.36 l42.784-67.936C511.823,119.791,512.591,115.408,511.567,111.247z' data-original='%23000000' class='active-path' data-old_color='%23e55d5c' fill='%23e55d5c'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cpath d='M256.015,160.015c-9.12,0-18.144,0.352-27.072,1.056l65.888,65.888c44.224,6.016,85.344,21.792,120.864,45.568 l34.048-54.112C394.127,181.583,327.567,160.015,256.015,160.015z' data-original='%23000000' class='active-path' data-old_color='%23e55d5c' fill='%23e55d5c'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cpath d='M337.647,269.775l48.928,48.928l12.064-19.168C379.951,286.959,359.375,277.103,337.647,269.775z' data-original='%23000000' class='active-path' data-old_color='%23e55d5c' fill='%23e55d5c'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cpath d='M256.015,352.015c-33.984,0-65.408,10.816-91.36,28.992l77.792,123.552c2.944,4.64,8.064,7.456,13.568,7.456 c5.504,0,10.624-2.816,13.536-7.456l77.792-123.552C321.423,362.831,289.999,352.015,256.015,352.015z' data-original='%23000000' class='active-path' data-old_color='%23e55d5c' fill='%23e55d5c'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A");
            @include font-size(s);
            @include border-radius($default-border-radius);
            color: #fff;
            font-family: $text;
            text-align: center;
            background-color: $error-light;
            margin: 12px 0 0 6px;
            padding: 40px 6px 6px 6px;
            display: block;
        }
    }
}
#menu-tools .menu-tool-icon.i-andy-menu-label {
    width: 36px;
    height: 36px;
    background-image: img('menu_label_dark.svg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    font-size: 0;

    &::before {
        content: none;
    }
}

#menu-tools .item.selected .menu-tool-icon.i-andy-menu-label {
    background-image: img('menu_label_light.svg');
}

.opened-menu #menu-tools .menu-tool-icon.i-andy-menu-label,
.opened-menu #menu-tools .item.selected .menu-tool-icon.i-andy-menu-label {
    background-image: img('menu_label.svg');
}
</style>
